import * as pbi from '../../public/index.component'
import { AdminService } from '../admin.service';
declare var jquery: any;
declare var $: any;
declare var ace: any;
declare var Layout: any;
@pbi.Component({
    selector: 'metatag',
    templateUrl: './metatag.component.html',
    styleUrls: ['./metatag.component.css']
})

export class MetatagComponent {
    pb_func: pbi.PublicComponent = new pbi.PublicComponent();
    items: Object[];
    PageTitle: string = "Quản lý Meta Tags";
    //#region  Meta Tag
    Title: string = "";
    ID: string = "-1";
    Meta: string = "";
    Name: string = "";
    NameVal: string = "";
    ContentVal: string = "";
    Active: boolean = false;
    Action: string = "";
    LinkOrg: string = "";
    //#endregion  Meta Tag
    constructor(private adminService: AdminService, private router: pbi.Router) {
        adminService.openLoading0();
    }
    ngOnInit() {
        var this_sav = this;
        var editModal = $('#EditMetatagModal');
        this_sav.pb_func.loadScript([
            'assets/global/scripts/datatable.js',
            'assets/global/plugins/datatables/datatables.min.js',
            'assets/global/plugins/datatables/plugins/bootstrap/datatables.bootstrap.js',
            'assets/more/script/fixHeightContent.js'
        ], 'metatag', function () {
            this_sav.tableMetatag();
        });
    };

    //#region Load Table Select
    tableMetatag() {
        var this_sav = this;
        var url = this_sav.pb_func.getBaseUrl() + "api/Metatag/load";
        var table = $('#datatable_ajax');
        
        var tbl = table.DataTable({
            "bProcessing": true,
            "bServerSide": true,
            "sAjaxSource": url,
            "bSort" : false,
            "fnServerData": function (sSource, aoData, fnCallback, oSettings) {
                oSettings.jqXHR = $.ajax({
                    "dataType": 'json',
                    "type": "POST",
                    "url": sSource,
                    "data": aoData,
                    "headers": { 'Authorization': this_sav.pb_func.getToken() },
                    "success": function(json) {
                        this_sav.items = json.aaData;
                        if (this_sav.items.length > 0) {
                            this_sav.LinkOrg = this_sav.items[0]["LinkOrg"];
                        }
                        fnCallback(json);
                    },
                });
            },
            "columns": [
                { "data": null },
                { "data": "Meta" },
                { "data": "Name" },
                { "data": "NameVal" },
                { "data": "ContentVal" },
                { "data": "Active" },
                { "data": "Action" }
            ],
            "lengthMenu": [
                [5],
                [5]
            ],
            "pageLength": 5,
            "drawCallback": function (settings) {
                $('.EditMetatagModal').off('click');
                $('.EditMetatagModal').click(function () {
                    this_sav.EditMetatagModal(this, $(this).attr('idsp'), $(this).attr('typesp'));
                });
                
                $('.ActiveMetatagModal').off('click');
                $('.ActiveMetatagModal').click(function () {
                    this_sav.Active = $(this).prop('checked');
                    this_sav.ID = $(this).attr('idsp');
                    this_sav.UpdateMetatag(this, $(this).attr('typesp'));
                });
            },
            "rowCallback": function (row, data, displayNum, displayIndex, dataIndex) {
                var page = this.fnPagingInfo().iPage;
                var length = this.fnPagingInfo().iLength;
                var index = (page * length + (displayIndex + 1));
                $('td:eq(0)', row).html(index);
            },
            "initComplete": function (settings, json) {
                this_sav.adminService.closeLoading(() => {

                });
            }
        });
    }
    //#endregion Load Table Select

    //#region Modal
    EditMetatagModal($event, ID: string, type: string) {
        var this_sav = this;
        var a = $event.currentTarget;
        if (type != 'add') {
            a = $event;
        }
        var tr = $(a).parent().parent().parent();
        this_sav.ID = ID;
        
        var editModal = $('#EditMetatagModal');
        if (type == "add") {
            setTimeout(() => { editModal.find('input.autofocus').focus(); }, 500);
            this_sav.Meta = "meta";
            this_sav.Name = "name";
            this_sav.NameVal = "";
            this_sav.ContentVal = "";
            this_sav.Title = "Thêm mới Tag";
        }
        else if (type == "edit") {
            setTimeout(() => { editModal.find('input.autofocus').focus(); }, 500);
            var row = this_sav.items.filter(function (item) {
                return item["ID"] == ID;
            })[0];
            this_sav.Meta = row["Meta"];
            this_sav.Name = row["Name"];
            this_sav.NameVal = row["NameVal"];
            this_sav.ContentVal = row["ContentVal"];
            this_sav.Title = `Sửa Tag "${this_sav.NameVal}"`;
        }
        else if (type == "del") {
            var row = this_sav.items.filter(function (item) {
                return item["ID"] == ID;
            })[0];
            this_sav.Meta = row["Meta"];
            this_sav.Name = row["Name"];
            this_sav.NameVal = row["NameVal"];
            this_sav.ContentVal = row["ContentVal"];
            this_sav.Title = `Xóa Tag "${this_sav.NameVal}"`;
        }

        editModal.find('.Meta').val(this_sav.Meta);
        editModal.find('.Name').val(this_sav.Name);
        this_sav.Action = type;
        this_sav.Active = false;
        $(a).next().click();
    }
    //#endregion Modal

    //#region Add, Edit, Del
    UpdateMetatag($event, type: string) {
        var this_sav = this;
        var table = $('#datatable_ajax').DataTable();
        var editModal = $('#EditMetatagModal');
        var a = $event.currentTarget;
        if(a == null)
            a = $event;

        this_sav.Meta = editModal.find('.Meta').val();
        this_sav.Name = editModal.find('.Name').val();

        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/Metatag/Update', 'POST',
            {
                ID: this_sav.ID, Meta: this_sav.Meta,
                Name: this_sav.Name, NameVal: this_sav.NameVal,
                ContentVal: this_sav.ContentVal, Active: this_sav.Active, Type: type
            },
            null, function (status, mess) {
                this_sav.adminService.closeLoading(function () { });
                var elemNotify = editModal.find('.notifyModal');
                if(type == "updateActive") {
                    elemNotify = $;
                    if (status == 0) {
                        var checked = $(a).prop('checked');
                        $(a).prop('checked', checked !== true);
                    }
                }

                if (status == 0) {
                    elemNotify.notify(mess.toString(), { globalPosition: 'bottom right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    elemNotify.notify(mess.toString(), { globalPosition: 'bottom right', className: 'success' });
                }
            });
    }

    DeleteMetatag($event, type: string) {
        var this_sav = this;
        var table = $('#datatable_ajax').DataTable();
        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/Metatag/Delete', 'POST', { ID: this_sav.ID }, null, function (status, mess) {
            this_sav.adminService.closeLoading(function () {
                if (status == 0) {
                    $.notify(mess, { globalPosition: 'bottom right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    $.notify(mess, { globalPosition: 'bottom right', className: 'success' });
                }
                $('#DelMetatagModal .close').click();
            });
        });
    }
    //#endregion Add, Edit, Del
}


// WEBPACK FOOTER //
// ./src/app/admin/metatag/metatag.component.ts